import Make from './make'

const make = Make('auth/')

export const isLoggedIn = async (): Promise<boolean> => {
  const req = await make.get({
    endpoint: 'logged-in',
  })

  if (req.success) {
    return true
  }

  return false
}
